<script>
import * as API from '../../api/likes';
export default {
  name: 'LikeActionButton',
  components: {
    CpButton: require('../../button').default,
    CpBaseSvgIcon: require('../../base-svg-icon').default,
    LikeIcon: require('../icons/like').default,
    CpDialogAuthForm: require('../../auth-form/dialog-auth-form').default,
    LikeActionItem: require('./LikeActionItem').default,
    VueSimpleSpinner: require('../../vue-simple-spinner').default,
  },
  props: {
    liked: { type: Boolean },
    id: { type: [String, Number] },
    type: { type: String },
    onSuccess: { type: Function },
  },
  data() {
    return {
      currentlyLiked: this.liked,
      loading: false,
      showAuthModal: false,
      likes: [],
      likesLoading: false,
      btnClass: 'btnClass',
    };
  },
  computed: {
    authUser() {
      return this.$root.authUser;
    },
  },
  watch: {
    liked(newValue, oldValue) {
      if (newValue) {
        this.currentlyLiked = newValue;
      }
    },
  },
  methods: {
    async onClick() {
      this.loading = true;
      if (!this.authUser) {
        this.showAuthModal = true;
      } else {
        await this.handleLike();
      }
      this.loading = false;
    },
    async handleLike() {
      await API.like(this.id, this.type)
        .then(response => {
          this.currentlyLiked = response.liked;
          this.onSuccess(response.liked);
        })
        .catch(error => {
          console.warn(error.toString());
        });
    },
    handleCloseButton() {
      this.showAuthModal = false;
    },
    async loadLikesProfiles() {
      this.likesLoading = true;
      await API.likes(this.id, this.type, { page: 0 })
        .then((response) => {
            this.likes = response.likes;
        })
        .catch((error) => {
            console.warn(error);
        });
        this.likesLoading = false;
    },
  },
};
</script>

<template>
  <div class="like-button-container" @mouseenter="loadLikesProfiles">
    <cp-button noborder bold @click.prevent="onClick" :disabled="loading" :class="[btnClass, currentlyLiked ? 'liked' : '']">
      <cp-base-svg-icon :width="26" :height="26" viewBox="0 0 20 19" :icon-color="currentlyLiked ? 'var(--primary)' : 'var(--primary-blue-400)'" :stroke-color="'none'">
        <like-icon />
      </cp-base-svg-icon>
      <span v-if="!$root.isMobile" :class="currentlyLiked ? 'body primary' : 'body primary-blue-400-color'">Like</span>
    </cp-button>
    <div v-show="likes.length" class="item-container">
      <p class="body1 neutral6-color">Recent Likes:</p>
      <LikeActionItem v-for="like in likes" :key="like.id" :data="like" />
    </div>
    <cp-dialog-auth-form v-if="showAuthModal" :handleCloseButton="handleCloseButton" showSignUp :callback-action="handleLike" />
  </div>
</template>

<style scoped>
.button--darkgray-outline {
  transition: color 0.2s ease;
}
.btnClass {
  background-color: transparent;
}
.liked {
  color: var(--highlight);
}
.like-button-container {
  position: relative;
  display: inline-block;
}
.item-container {
  display: none;
  position: absolute;
  bottom: 100%;
  left: 0;
  background: white;
  border-radius: 8px;
  border: 1px solid var(--neutral3);
  padding: 8px;
  z-index: 10;
}
.like-button-container:hover .item-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.item-container p {
  margin: 4px 0;
}
</style>
